import React, { useState } from "react";
import UpcomingSession from "./UpcomingSessions";
import CompletedSession from "./CompletedSession";

const UserSession = () => {
  const [activeTab, setActiveTab] = useState("upcoming");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="font-josefin-sans white p-5 lg:py-16 lg:px-44 h-fit ">
      <div className="bg-blue-500 text-white mb-5 feedback py-5 lg:py-16 lg:mb-16 text-center text-xl md:text-3xl font-semibold rounded-lg">
        Your feedback is most important for us to improve your experience.
        Kindly provide feedback for all the completed sessions. It will take a
        maximum of 30 seconds.
      </div>
      <div className="flex space-x-4">
        <button
          onClick={() => handleTabClick("upcoming")}
          className={`${
            activeTab === "upcoming"
              ? "bg-blue-500 text-white"
              : "bg-gray-300 text-gray-800"
          } px-4 py-2 rounded-lg focus:outline-none`}
        >
          Upcoming Session
        </button>
        <button
          onClick={() => handleTabClick("completed")}
          className={`${
            activeTab === "completed"
              ? "bg-blue-500 text-white"
              : "bg-gray-300 text-gray-800"
          } px-4 py-2 rounded-lg focus:outline-none`}
        >
          Completed Session
        </button>
      </div>
      <div>
        {activeTab === "upcoming" ? <UpcomingSession /> : null}
        {activeTab === "completed" ? <CompletedSession /> : null}
      </div>
    </div>
  );
};

export default UserSession;
